module.exports = __webpack_public_path__ + "static/media/versace_bags.2a221cec.jpg";